import React, { useState } from 'react'
import Header from '../../components/application/emiCalculator/header'
import EmiCalculation from '../../components/application/emiCalculator/emiCalculation'

function EmiCalculator() {

  return (
    <>
      <Header/>
      <EmiCalculation/>
    </>
  )
}

export default EmiCalculator